import { useState } from 'react';
import useFetch from '../../../hooks/useFetch';
import { buildEndpoint } from '../EndPoints';
import { ServiceEvents } from '../shared/interfaces';

const useFAQService = () => {
    const { doGet, doPost } = useFetch();
    
    // Estados de carga
    const [fetchingGetFAQs, setFetchingGetFAQs] = useState(false);
    const [fetchingStoreFAQ, setFetchingStoreFAQ] = useState(false);
    const [fetchingShowFAQ, setFetchingShowFAQ] = useState(false);
    const [fetchingUpdateFAQ, setFetchingUpdateFAQ] = useState(false);
    const [fetchingDeleteFAQ, setFetchingDeleteFAQ] = useState(false);
    const [fetchingActiveFAQ, setFetchingActiveFAQ] = useState(false);
    
    const BASE_PATH = 'faqs';
    
    /**
     * Obtener listado de FAQs
     * @param filters - Filtros opcionales (search, is_active)
     */
    const getFAQs = (filters: Record<string, any> = {}, events: ServiceEvents = {}) => {
        const queryString = Object.entries(filters)
            .filter(([_, value]) => value !== undefined && value !== '')
            .map(([key, value]) => `${key}=${value}`)
            .join('&');
            
        doGet({
            ...events,
            url: buildEndpoint(`${BASE_PATH}/${queryString ? `?${queryString}` : ''}`),
            setFetching: setFetchingGetFAQs
        });
    };
    
    /**
     * Crear FAQ
     */
    const storeFAQ = (data: Record<string, any>, events: ServiceEvents = {}) => {
        doPost({
            ...events,
            url: buildEndpoint(`${BASE_PATH}/store`),
            body: data,
            setFetching: setFetchingStoreFAQ
        });
    };
    
    /**
     * Ver FAQ
     */
    const showFAQ = (id: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: buildEndpoint(`${BASE_PATH}/${id}/show`),
            setFetching: setFetchingShowFAQ
        });
    };
    
    /**
     * Actualizar FAQ
     */
    const updateFAQ = (id: number, data: Record<string, any>, events: ServiceEvents = {}) => {
        doPost({
            ...events,
            url: buildEndpoint(`${BASE_PATH}/${id}/update`),
            body: data,
            setFetching: setFetchingUpdateFAQ
        });
    };
    
    /**
     * Eliminar FAQ
     */
    const deleteFAQ = (id: number, events: ServiceEvents = {}) => {
        doPost({
            ...events,
            url: buildEndpoint(`${BASE_PATH}/${id}/delete`),
            body: {},
            setFetching: setFetchingDeleteFAQ
        });
    };
    
    /**
     * Activar/Desactivar FAQ
     */
    const activeFAQ = (id: number, isActive: boolean, events: ServiceEvents = {}) => {
        doPost({
            ...events,
            url: buildEndpoint(`${BASE_PATH}/${id}/active`),
            body: { is_active: isActive },
            setFetching: setFetchingActiveFAQ
        });
    };
    
    return {
        // Métodos
        getFAQs,
        storeFAQ,
        showFAQ,
        updateFAQ,
        deleteFAQ,
        activeFAQ,
        // Estados de carga
        fetchingGetFAQs,
        fetchingStoreFAQ,
        fetchingShowFAQ,
        fetchingUpdateFAQ,
        fetchingDeleteFAQ,
        fetchingActiveFAQ
    };
};

export default useFAQService;

